import { StringNameAvatar } from '@/components/lemmala-design-system/avatar'

type EvidenceQuotesProps = {
  quotes: string[]
  businessOwnerName?: string
}

export const EvidenceQuotes = ({ quotes, businessOwnerName }: EvidenceQuotesProps) => {
  const nonEmpty = quotes.filter((q) => q.trim())
  if (nonEmpty.length === 0) return null
  return (
    <div className='flex flex-col gap-2'>
      {nonEmpty.map((quote, i) => (
        <div
          key={i}
          className='flex items-start gap-2 rounded bg-main-background-subtle-semantic-ai px-2.5 py-2'
        >
          {businessOwnerName && (
            <StringNameAvatar name={businessOwnerName} maxLength={1} size='small' />
          )}
          <span className='text-main-foreground-primary text-body-small'>{quote}</span>
        </div>
      ))}
    </div>
  )
}
